module.exports = __webpack_public_path__ + "static/media/pw-rating-active-icon.392670a8.svg";